var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.003 5.535l2.514-2.514a1.079 1.079 0 1 1 1.526 1.525L4.788 19.801a1.079 1.079 0 1 1-1.526-1.525L6 15.538V10a5.997 5.997 0 0 1 4.5-5.805V3.5a1.5 1.5 0 0 1 3 0v.695c.944.244 1.798.71 2.503 1.34zm1.888 3.32c.071.37.109.754.109 1.145v6l2 2v1H7.746L17.891 8.856zM10 20c0 1.1.9 2 2 2s2-.9 2-2h-4z",
    id: "alert-off-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#alert-off-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOff);
export default __webpack_public_path__ + "static/media/alert-off.85861ff5084e8ce24e5772876c3461d1.svg";
export { ForwardRef as ReactComponent };